import jsPDF from 'jspdf';

export const PDF_FONT_FAMILY = 'pdf-font';
export const PDF_FONT_MAIN_COLOR = '#464646';
const PDF_FONT_REGULAR_FILE = 'pdf-regular.ttf';
const PDF_FONT_BOLD_FILE = 'pdf-bold.ttf';
const PDF_FONT_REGULAR_URL = `${process.env.PUBLIC_URL}/fonts/${PDF_FONT_FAMILY}/${PDF_FONT_REGULAR_FILE}`;
const PDF_FONT_BOLD_URL = `${process.env.PUBLIC_URL}/fonts/${PDF_FONT_FAMILY}/${PDF_FONT_BOLD_FILE}`;
const fontDataCache = new Map<string, Promise<string>>();

export async function registerPdfFonts(pdf: jsPDF): Promise<void> {
  const [regularFontData, boldFontData] = await Promise.all([
    loadFontData(PDF_FONT_REGULAR_URL),
    loadFontData(PDF_FONT_BOLD_URL),
  ]);

  pdf.addFileToVFS(PDF_FONT_REGULAR_FILE, regularFontData);
  pdf.addFileToVFS(PDF_FONT_BOLD_FILE, boldFontData);
  pdf.addFont(PDF_FONT_REGULAR_FILE, PDF_FONT_FAMILY, 'normal');
  pdf.addFont(PDF_FONT_BOLD_FILE, PDF_FONT_FAMILY, 'bold');
}

function loadFontData(fontUrl: string): Promise<string> {
  const cached = fontDataCache.get(fontUrl);
  if (cached) {
    return cached;
  }

  const fontPromise = fetch(fontUrl)
    .then(async (response) => {
      if (!response.ok) {
        throw new Error(`Failed to load PDF font: ${fontUrl}`);
      }

      return response.arrayBuffer();
    })
    .then(arrayBufferToBase64);

  fontDataCache.set(fontUrl, fontPromise);
  return fontPromise;
}

function arrayBufferToBase64(buffer: ArrayBuffer): string {
  const bytes = new Uint8Array(buffer);
  const chunkSize = 0x8000; // 32KB per batch: prevents call stack overflow for large fonts
  let binary = '';

  for (let index = 0; index < bytes.length; index += chunkSize) {
    const chunk = bytes.subarray(index, index + chunkSize);
    for (let chunkIndex = 0; chunkIndex < chunk.length; chunkIndex += 1) {
      binary += String.fromCharCode(chunk[chunkIndex]);
    }
  }

  return btoa(binary);
}
